import { h as head, c as attr_class, e as escape_html, m as stringify, p as pop, a as push } from "../../../../../chunks/index2.js";
import "@sveltejs/kit/internal";
import "../../../../../chunks/exports.js";
import "../../../../../chunks/utils.js";
import "clsx";
import "../../../../../chunks/state.svelte.js";
function _page($$payload, $$props) {
  push();
  const { data } = $$props;
  const legislation = data.legislation;
  const formatDate = (dateString) => {
    if (!dateString) return "Not specified";
    return new Date(dateString).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  };
  const getTypeIcon = (type) => {
    switch (type) {
      case "ACT":
        return "bi-journal-text";
      case "SUBLEG":
        return "bi-file-earmark-text";
      case "CORRIGENDA":
        return "bi-pencil-square";
      default:
        return "bi-file-text";
    }
  };
  const getStatusBadge = (status) => {
    if (!status) return "bg-gray-100 text-gray-800";
    switch (status.toUpperCase()) {
      case "ONLINE":
        return "bg-green-100 text-green-800";
      case "PENDING":
        return "bg-yellow-100 text-yellow-800";
      case "OFFLINE":
        return "bg-red-100 text-red-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };
  head($$payload, ($$payload2) => {
    $$payload2.title = `<title>${escape_html(legislation.title || `${legislation.type} ${legislation.number}`)} - Legislation Details</title>`;
  });
  $$payload.out.push(`<div class="container mx-auto p-6"><div class="mb-8"><div class="mb-4 flex items-center gap-4"><button class="rounded-lg p-2 text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-800" title="Back to legislation list"><i class="bi-arrow-left text-xl"></i></button> <div class="flex items-center gap-3"><i${attr_class(`${stringify(getTypeIcon(legislation.type))} text-primary text-2xl`)}></i> <div><h1 class="text-fadeblack text-3xl font-bold">${escape_html(legislation.title || `${legislation.type} ${legislation.number}`)}</h1> <div class="mt-2 flex items-center gap-4"><span class="text-gray-600">Year: ${escape_html(legislation.year)}</span> `);
  if (legislation.number) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<span class="text-gray-600">Number: ${escape_html(legislation.number)}</span>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> `);
  if (legislation.statusOnDatabase) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<span${attr_class(`inline-flex rounded-full px-2 py-1 text-xs font-medium ${stringify(getStatusBadge(legislation.statusOnDatabase))}`)}>${escape_html(legislation.statusOnDatabase)}</span>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div></div></div></div></div> <div class="grid grid-cols-1 gap-8 lg:grid-cols-3"><div class="space-y-8 lg:col-span-2"><div class="rounded-lg border border-gray-200 bg-white p-6 shadow-sm"><h2 class="mb-6 flex items-center gap-2 text-xl font-semibold text-gray-900"><i class="bi-info-circle text-primary"></i> Basic Information</h2> <div class="grid grid-cols-1 gap-6 md:grid-cols-2"><div><label class="mb-1 block text-sm font-medium text-gray-700">Year</label> <p class="text-gray-900">${escape_html(legislation.year)}</p></div> <div><label class="mb-1 block text-sm font-medium text-gray-700">Type</label> <div class="flex items-center gap-2"><i${attr_class(`${stringify(getTypeIcon(legislation.type))} text-primary`)}></i> <span class="text-gray-900">${escape_html(legislation.type)}</span></div></div> `);
  if (legislation.number) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div><label class="mb-1 block text-sm font-medium text-gray-700">Number</label> <p class="text-gray-900">${escape_html(legislation.number)}</p></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> `);
  if (legislation.statusOnDatabase) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div><label class="mb-1 block text-sm font-medium text-gray-700">Status on Database</label> <span${attr_class(`inline-flex rounded-full px-3 py-1 text-sm font-medium ${stringify(getStatusBadge(legislation.statusOnDatabase))}`)}>${escape_html(legislation.statusOnDatabase)}</span></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div> `);
  if (legislation.title) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="mt-6"><label class="mb-1 block text-sm font-medium text-gray-700">Title</label> <p class="leading-relaxed text-gray-900">${escape_html(legislation.title)}</p></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div> <div class="rounded-lg border border-gray-200 bg-white p-6 shadow-sm"><h2 class="mb-6 flex items-center gap-2 text-xl font-semibold text-gray-900"><i class="bi-newspaper text-primary"></i> Publication Details</h2> <div class="grid grid-cols-1 gap-6 md:grid-cols-2">`);
  if (legislation.gazetteDetails) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div><label class="mb-1 block text-sm font-medium text-gray-700">Gazette Details</label> <p class="text-gray-900">${escape_html(legislation.gazetteDetails)}</p></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> `);
  if (legislation.kenyaGazetteSuppNo) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div><label class="mb-1 block text-sm font-medium text-gray-700">Kenya Gazette Supplement No.</label> <p class="text-gray-900">${escape_html(legislation.kenyaGazetteSuppNo)}</p></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> `);
  if (legislation.pagination) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div><label class="mb-1 block text-sm font-medium text-gray-700">Pagination</label> <p class="text-gray-900">${escape_html(legislation.pagination)}</p></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> `);
  if (legislation.availability) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div><label class="mb-1 block text-sm font-medium text-gray-700">Availability</label> <p class="text-gray-900">${escape_html(legislation.availability)}</p></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div></div> `);
  if (legislation.revocationsAmendments || legislation.legislativeUpdates || legislation.comments) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="rounded-lg border border-gray-200 bg-white p-6 shadow-sm"><h2 class="mb-6 flex items-center gap-2 text-xl font-semibold text-gray-900"><i class="bi-text-paragraph text-primary"></i> Additional Information</h2> <div class="space-y-6 svelte-1e98oac">`);
    if (legislation.revocationsAmendments) {
      $$payload.out.push("<!--[-->");
      $$payload.out.push(`<div class="svelte-1e98oac"><label class="mb-2 block text-sm font-medium text-gray-700">Revocations/Amendments</label> <p class="rounded-lg bg-gray-50 p-4 leading-relaxed text-gray-900">${escape_html(legislation.revocationsAmendments)}</p></div>`);
    } else {
      $$payload.out.push("<!--[!-->");
    }
    $$payload.out.push(`<!--]--> `);
    if (legislation.legislativeUpdates) {
      $$payload.out.push("<!--[-->");
      $$payload.out.push(`<div class="svelte-1e98oac"><label class="mb-2 block text-sm font-medium text-gray-700">Legislative Updates</label> <p class="rounded-lg bg-gray-50 p-4 leading-relaxed text-gray-900">${escape_html(legislation.legislativeUpdates)}</p></div>`);
    } else {
      $$payload.out.push("<!--[!-->");
    }
    $$payload.out.push(`<!--]--> `);
    if (legislation.comments) {
      $$payload.out.push("<!--[-->");
      $$payload.out.push(`<div class="svelte-1e98oac"><label class="mb-2 block text-sm font-medium text-gray-700">Comments</label> <p class="rounded-lg bg-gray-50 p-4 leading-relaxed text-gray-900">${escape_html(legislation.comments)}</p></div>`);
    } else {
      $$payload.out.push("<!--[!-->");
    }
    $$payload.out.push(`<!--]--></div></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div> <div class="space-y-6 svelte-1e98oac"><div class="rounded-lg border border-gray-200 bg-white p-6 shadow-sm svelte-1e98oac"><h3 class="mb-4 flex items-center gap-2 text-lg font-semibold text-gray-900"><i class="bi-calendar-event text-primary"></i> Important Dates</h3> <div class="space-y-4">`);
  if (legislation.dateGazetted) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="flex items-center gap-3 rounded-lg bg-gray-50 p-3"><i class="bi-calendar-check text-green-600"></i> <div><p class="text-sm font-medium text-gray-700">Date Gazetted</p> <p class="text-gray-900">${escape_html(formatDate(legislation.dateGazetted))}</p></div></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> `);
  if (legislation.availabilityAt) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="flex items-center gap-3 rounded-lg bg-gray-50 p-3"><i class="bi-calendar-plus text-blue-600"></i> <div><p class="text-sm font-medium text-gray-700">Availability Date</p> <p class="text-gray-900">${escape_html(formatDate(legislation.availabilityAt))}</p></div></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> `);
  if (legislation.uploadedAt) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="flex items-center gap-3 rounded-lg bg-gray-50 p-3"><i class="bi-cloud-upload text-purple-600"></i> <div><p class="text-sm font-medium text-gray-700">Upload Date</p> <p class="text-gray-900">${escape_html(formatDate(legislation.uploadedAt))}</p></div></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> `);
  if (legislation.kgsPublicationAt) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="flex items-center gap-3 rounded-lg bg-gray-50 p-3"><i class="bi-newspaper text-orange-600"></i> <div><p class="text-sm font-medium text-gray-700">KGS Publication Date</p> <p class="text-gray-900">${escape_html(formatDate(legislation.kgsPublicationAt))}</p></div></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> `);
  if (legislation.commencementAt) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="flex items-center gap-3 rounded-lg bg-gray-50 p-3"><i class="bi-play-circle text-green-600"></i> <div><p class="text-sm font-medium text-gray-700">Commencement Date</p> <p class="text-gray-900">${escape_html(formatDate(legislation.commencementAt))}</p></div></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> `);
  if (legislation.assentAt) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="flex items-center gap-3 rounded-lg bg-gray-50 p-3"><i class="bi-check-circle text-indigo-600"></i> <div><p class="text-sm font-medium text-gray-700">Assent Date</p> <p class="text-gray-900">${escape_html(formatDate(legislation.assentAt))}</p></div></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> `);
  if (legislation.dateAvailedAt) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="flex items-center gap-3 rounded-lg bg-gray-50 p-3"><i class="bi-check2-circle text-teal-600"></i> <div><p class="text-sm font-medium text-gray-700">Date Availed</p> <p class="text-gray-900">${escape_html(formatDate(legislation.dateAvailedAt))}</p></div></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div></div> <div class="rounded-lg border border-gray-200 bg-white p-6 shadow-sm svelte-1e98oac"><h3 class="mb-4 flex items-center gap-2 text-lg font-semibold text-gray-900"><i class="bi-lightning text-primary"></i> Quick Actions</h3> <div class="space-y-3"><button class="flex w-full items-center gap-3 rounded-lg border border-gray-200 p-3 text-left transition-colors hover:bg-gray-50"><i class="bi-pencil-square text-primary"></i> <span class="text-gray-900">Edit Legislation</span></button> <button class="flex w-full items-center gap-3 rounded-lg border border-gray-200 p-3 text-left transition-colors hover:bg-gray-50"><i class="bi-printer text-gray-600"></i> <span class="text-gray-900">Print Details</span></button> <button class="flex w-full items-center gap-3 rounded-lg border border-gray-200 p-3 text-left transition-colors hover:bg-gray-50"><i class="bi-arrow-left text-gray-600"></i> <span class="text-gray-900">Back to List</span></button></div></div></div></div></div>`);
  pop();
}
export {
  _page as default
};
